export const TYPE_PRODUIT = {
  lecture: { module: 'presse', element: 'type_produit', rule: 'lecture' },
  maj: { module: 'presse', element: 'type_produit', rule: 'maj' },
  exporter: { module: 'presse', element: 'type_produit', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'type_produit', rule: 'supprimer' },
};

export const COULEUR_ENCART = {
  lecture: { module: 'presse', element: 'couleur_encart', rule: 'lecture' },
  maj: { module: 'presse', element: 'couleur_encart', rule: 'maj' },
  exporter: { module: 'presse', element: 'couleur_encart', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'couleur_encart', rule: 'supprimer' },
};

export const REGLE_FACTURATION = {
  lecture: { module: 'presse', element: 'regle_facturation', rule: 'lecture' },
  maj: { module: 'presse', element: 'regle_facturation', rule: 'maj' },
  exporter: { module: 'presse', element: 'regle_facturation', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'regle_facturation', rule: 'supprimer' },
};

export const PERIODICITE = {
  lecture: { module: 'presse', element: 'periodicite', rule: 'lecture' },
  maj: { module: 'presse', element: 'periodicite', rule: 'maj' },
  exporter: { module: 'presse', element: 'periodicite', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'periodicite', rule: 'supprimer' },
};

export const EMPLACEMENT_PRESSE = {
  lecture: { module: 'presse', element: 'emplacement_presse', rule: 'lecture' },
  maj: { module: 'presse', element: 'emplacement_presse', rule: 'maj' },
  exporter: { module: 'presse', element: 'emplacement_presse', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'emplacement_presse', rule: 'supprimer' },
};

export const SURFACE = {
  lecture: { module: 'presse', element: 'surface', rule: 'lecture' },
  maj: { module: 'presse', element: 'surface', rule: 'maj' },
  exporter: { module: 'presse', element: 'surface', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'surface', rule: 'supprimer' },
};

export const MODE_DISTRIBUTION = {
  lecture: { module: 'presse', element: 'mode_distribution', rule: 'lecture' },
  maj: { module: 'presse', element: 'mode_distribution', rule: 'maj' },
  exporter: { module: 'presse', element: 'mode_distribution', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'mode_distribution', rule: 'supprimer' },
};

export const FOURNISSEUR_SUPPORT = {
  lecture: { module: 'presse', element: 'fournisseur_support', rule: 'lecture' },
  maj: { module: 'presse', element: 'fournisseur_support', rule: 'maj' },
  exporter: { module: 'presse', element: 'fournisseur_support', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'fournisseur_support', rule: 'supprimer' },
};

export const TYPE_EVENEMENT_SPONSORING = {
  lecture: { module: 'presse', element: 'type_evenement_sponsoring', rule: 'lecture' },
  maj: { module: 'presse', element: 'type_evenement_sponsoring', rule: 'maj' },
  exporter: { module: 'presse', element: 'type_evenement_sponsoring', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'type_evenement_sponsoring', rule: 'supprimer' },
};

export const TYPE_FORMAT_PRESSE = {
  lecture: { module: 'presse', element: 'type_format_presse', rule: 'lecture' },
  maj: { module: 'presse', element: 'type_format_presse', rule: 'maj' },
  exporter: { module: 'presse', element: 'type_format_presse', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'type_format_presse', rule: 'supprimer' },
};

export const PARUTION = {
  lecture: { module: 'presse', element: 'parution', rule: 'lecture' },
  maj: { module: 'presse', element: 'parution', rule: 'maj' },
  exporter: { module: 'presse', element: 'parution', rule: 'exporter' },
  editer: { module: 'presse', element: 'parution', rule: 'edition' },
  supprimer: { module: 'presse', element: 'parution', rule: 'supprimer' },
};

export const PLAN_MEDIA = {
  lecture: { module: 'presse', element: 'plan_media', rule: 'lecture' },
  maj: { module: 'presse', element: 'plan_media', rule: 'maj' },
  exporter: { module: 'presse', element: 'plan_media', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'plan_media', rule: 'supprimer' },
};

export const TYPE_EVENEMENT = {
  lecture: { module: 'presse', element: 'type_evenement_pm', rule: 'lecture' },
  maj: { module: 'presse', element: 'type_evenement_pm', rule: 'maj' },
  exporter: { module: 'presse', element: 'type_evenement_pm', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'type_evenement_pm', rule: 'supprimer' },
};

export const MOIS_COMPTABLE = {
  lecture: { module: 'presse', element: 'mois_comptable', rule: 'lecture' },
  maj: { module: 'presse', element: 'mois_comptable', rule: 'maj' },
  exporter: { module: 'presse', element: 'mois_comptable', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'mois_comptable', rule: 'supprimer' },
  editer: { module: 'presse', element: 'mois_comptable', rule: 'edition' },
};

export const ETAT_SUIVI_ADMINISTRATIF = {
  lecture: { module: 'presse', element: 'etat_suivi_administratif', rule: 'lecture' },
  maj: { module: 'presse', element: 'etat_suivi_administratif', rule: 'maj' },
  exporter: { module: 'presse', element: 'etat_suivi_administratif', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'etat_suivi_administratif', rule: 'supprimer' },
};

export const CHEMIN_FER = {
  lecture: { module: 'presse', element: 'chemin_fer', rule: 'lecture' },
  maj: { module: 'presse', element: 'chemin_fer', rule: 'maj' },
  exporter: { module: 'presse', element: 'chemin_fer', rule: 'exporter' },
  supprimer: { module: 'presse', element: 'chemin_fer', rule: 'supprimer' },
};
